import {Component, Input, ViewEncapsulation} from '@angular/core';

/**
 * @group Nav Sidebar
 * @component Nav Sidebar
 * @description Nav Sidebar
 */
@Component({
  selector: 'la-nav-sidebar',
  template: `
    <nav class="la-nav-sidebar" [ngClass]="{'la-nav-sidebar--compact': isCompact}">
      <ng-content></ng-content>
    </nav>`,
  styles: [`
    .la-nav-sidebar{border:none;margin:0;padding:0;height:100%;justify-content:flex-start}.la-nav-sidebar,.la-nav-sidebar .la-icon-button{width:120px;display:flex;flex-direction:column;align-items:center}.la-nav-sidebar .la-icon-button{height:92px;justify-content:center}.la-nav-sidebar .la-icon-button .la-icon{fill:rgba(3,20,34,.4)}.la-nav-sidebar .la-icon-button .la-text{color:rgba(3,20,34,.4)}.la-nav-sidebar .la-icon-button--hover .la-icon{fill:rgba(3,20,34,.55)}.la-nav-sidebar .la-icon-button--hover .la-text{color:rgba(3,20,34,.55)}.la-nav-sidebar .la-icon-button--active .la-icon{fill:rgba(3,20,34,.8)}.la-nav-sidebar .la-icon-button--active .la-text{color:rgba(3,20,34,.8)}.la-nav-sidebar.la-nav-sidebar--compact .la-icon-button{height:64px}.la-nav-sidebar.la-nav-sidebar--compact la-text{display:none}
  `],
  encapsulation: ViewEncapsulation.None
})
export class LaNavSidebarComponent {

  private _isCompact = false;

  get isCompact(): boolean {
    return this._isCompact;
  }

  @Input()
  set isCompact(value: boolean) {
    this._isCompact = value;
  }
}
